import { Link } from "react-router-dom";
import { useManagementList } from "../../hooks/useManagementList";
import { useReportsHome } from "../../hooks/useReportsHome";
import { useRegulationsHome } from "../../hooks/useRegulationsHome";
import { useNewsHome } from "../../hooks/useNewsHome";
import { useFaqsHome } from "../../hooks/useFaqsHome";

const Beranda = () => {
    const { data: board } = useManagementList();
    const { data: reports } = useReportsHome();
    const { data: regulations } = useRegulationsHome();
    const { data: beritaData } = useNewsHome();
    const { data: faqs } = useFaqsHome();

    const truncateMultiline = (lines) => {
        return {
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: lines,
            overflow: "hidden",
        };
    };

    function stripHtml(html) {
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent || div.innerText || "";
    }

    return (
        <>
            <header className="relative w-full  h-screen overflow-hidden bg-white">
                <img
                    src="/images/asset/new-hero-dapen.svg"
                    alt="Hero"
                    className="
        absolute inset-0
        w-full h-full
        object-cover
        pointer-events-none select-none
      "
                    style={{
                        objectPosition: "center",
                    }}
                />

                <div className="relative z-10 flex flex-col items-center justify-between h-full pt-18 pb-10 px-4 text-white text-center">
                    <div className="flex items-center justify-center min-h-[400px]">
                        <div className="mb-6 max-w-2xl text-center">
                            <h1 className="flex flex-wrap items-center justify-center gap-2 text-3xl sm:text-4xl md:text-5xl font-semibold leading-snug">
                                <span className="bg-white text-red-600 px-3 py-1 rounded font-pontano">
                                    Dana Pensiun Toyota Astra
                                </span>
                            </h1>
                            <p className="mt-3 text-sm sm:text-base md:text-lg drop-shadow-sm font-inter bg-white text-red-600">
                                Untuk kehidupan karyawan setelah masa purna
                                bakti.
                            </p>
                        </div>
                    </div>
                </div>
            </header>

            <section className="relative z-20 bg-[#F1F1F1] rounded-t-[40px] -mt-12 sm:-mt-16 px-4 sm:px-8 lg:px-24 py-8 sm:py-12">
                <div className="flex flex-col-reverse lg:flex-row items-center gap-8 lg:gap-16">
                    <div className="flex-1 flex justify-center">
                        <img
                            src="/images/asset/rupiah.svg"
                            alt="rupiah-icon"
                            className="w-34 h-34 lg:w-42 lg:h-42"
                        />
                    </div>
                    <div className="flex-1 text-center lg:text-left">
                        <h2 className="text-2xl sm:text-3xl font-semibold mb-4 font-pontano">
                            Dana Pensiun Toyota Astra
                        </h2>
                        <p className="text-gray-600 text-sm sm:text-base font-inter">
                            Dana Pensiun Toyota Astra adalah Dana Pensiun
                            Pemberi Kerja, dengan program manfaat pasti.
                            Didirikan pada tanggal 16 April 1993 sebagai
                            penerapan dari Undang Undang Dana Pensiun nomor 11
                            tahun 1992. Sebagai pendiri adalah PT. Toyota Motor
                            Manufacturing Indoneia, sedangkan sebagai Mitra
                            Pendiri adalah PT. Toyota Astra Motor. Pesertanya
                            adalah semua karyawan PT. Toyota Motor Manufacturing
                            Indonesia dan PT. Toyota Astra Motor yang diangkat
                            sampai dengan tanggal 31 Desember 2011.
                        </p>
                    </div>
                </div>

                <div className="bg-white shadow rounded-2xl p-6 mt-12">
                    <div className="grid sm:grid-cols-2 gap-6">
                        <div className="flex items-start gap-4">
                            <div className="mt-1 w-12 h-12 min-w-[48px]">
                                <img
                                    src="/images/asset/visi-misi.svg"
                                    alt="Visi Icon"
                                    className="w-full h-full object-contain"
                                />
                            </div>
                            <div>
                                <h3 className="font-bold text-lg font-pontano">
                                    Visi Dana Pensiun Toyota Astra
                                </h3>
                                <p className="text-sm text-gray-600 font-inter">
                                    Menjadi Dana Pensiun yang sehat untuk
                                    menunjang kepentingan Pendiri dan Mitra
                                    Pendiri serta Kesinambungan Penghasilan
                                    Peserta.
                                </p>
                            </div>
                        </div>
                        <div className="flex items-start gap-4">
                            <div className="mt-1 w-12 h-12 min-w-[48px]">
                                <img
                                    src="/images/asset/visi-misi.svg"
                                    alt="Misi Icon"
                                    className="w-full h-full object-contain"
                                />
                            </div>
                            <div>
                                <h3 className="font-bold text-lg font-pontano">
                                    Misi Dana Pensiun Toyota Astra
                                </h3>
                                <p className="text-sm text-gray-600 font-inter">
                                    . Mengelola Aset Dana Pensiun sesuai dengan
                                    arahan investasi
                                    <br />. Menyelenggarakan dana Pensiun yang
                                    transparan, akuntabel, dan bertanggung jawab
                                    untuk semua stakeholder <br />. Memberikan
                                    pelayanan terbaik kepada Pendiri, Mitra
                                    Pendiri, dan Peserta.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="text-center mt-12">
                    <h2 className="text-2xl font-semibold mb-6 font-pontano">
                        Susunan Pengurus Dana Pensiun Toyota Astra
                    </h2>
                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 max-w-4xl mx-auto">
                        {board.length > 0 ? (
                            board.map((member, idx) => (
                                <div
                                    key={idx}
                                    className="overflow-hidden text-center"
                                >
                                    <img
                                        src={member.thumbnail}
                                        alt={member.name}
                                        className="w-full h-auto"
                                    />
                                    <div className="p-4">
                                        <h3 className="font-semibold text-base text-gray-900 font-pontano">
                                            {member.name}
                                        </h3>
                                        <p className="text-sm text-gray-600 font-inter">
                                            {member.jabatan}
                                        </p>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="text-center text-gray-500 col-span-full">
                                Data Pengurus Dana Pensiun Toyota Astra belum
                                tersedia
                            </p>
                        )}
                    </div>
                </div>

                <div className="text-center mt-8">
                    <Link
                        to="/tentang-kami"
                        className="text-[#EB0A1E] text-sm font-bold inline-flex items-center gap-1 hover:underline"
                    >
                        Selengkapnya{" "}
                        <img
                            src="/images/asset/arrow.svg"
                            alt="arrow"
                            className="w-4 h-4 object-contain"
                        />
                    </Link>
                </div>
            </section>

            <section className="bg-white px-4 sm:px-8 lg:px-24 py-12">
                <div className="text-center mt-12">
                    <h2 className="text-2xl font-semibold mb-6 font-pontano">
                        Laporan Dana Pensiun Toyota Astra
                    </h2>

                    <div className="mb-10 text-left">
                        <div className="grid grid-cols-1 gap-4 max-w-5xl mx-auto place-items-center">
                            {reports.length > 0 ? (
                                reports.map((report, idx) => (
                                    <div
                                        key={idx}
                                        className="bg-white p-4 rounded-xl shadow flex items-center justify-between gap-4 w-full max-w-lg mx-auto"
                                    >
                                        <div className="flex-1 min-w-0">
                                            <span className="text-xs font-medium text-red-500 font-inter">
                                                Laporan
                                            </span>
                                            <span className="block text-sm font-semibold text-gray-800 font-pontano truncate">
                                                {report.judul}
                                            </span>
                                        </div>

                                        <a
                                            href={report.dokumen}
                                            download
                                            className="shrink-0 inline-flex items-center gap-2 px-3 py-1.5 bg-[#EB0A1E] text-white text-sm rounded-md hover:bg-red-700 transition"
                                        >
                                            Download
                                            <img
                                                src="/images/asset/download.svg"
                                                alt="Download"
                                                className="w-4 h-4"
                                            />
                                        </a>
                                    </div>
                                ))
                            ) : (
                                <p className="text-center text-gray-500">
                                    Data laporan belum tersedia.
                                </p>
                            )}
                        </div>
                    </div>

                    <div className="text-center">
                        <h3 className="text-2xl font-semibold mb-6 font-pontano">
                            Peraturan POJK Terkait Industri Dana Pensiun
                        </h3>
                        <div className="grid grid-cols-1 gap-4 max-w-5xl mx-auto place-items-center">
                            {regulations.length > 0 ? (
                                regulations.map((report, idx) => (
                                    <div
                                        key={idx}
                                        className="bg-white p-4 rounded-xl shadow flex items-center justify-between gap-4 w-full max-w-lg"
                                    >
                                        <div className="flex flex-col justify-center text-left">
                                            <span className="text-xs font-medium text-red-500 font-inter">
                                                Peraturan
                                            </span>
                                            <span className="text-sm font-semibold text-gray-800 font-pontano">
                                                {report.judul}
                                            </span>
                                        </div>
                                        <div className="self-center">
                                            <a
                                                href={report.dokumen}
                                                download
                                                className="inline-flex items-center gap-2 px-3 py-1.5 bg-[#EB0A1E] text-white text-sm rounded-md hover:bg-red-700 transition self-start"
                                            >
                                                Download
                                                <img
                                                    src="/images/asset/download.svg"
                                                    alt="Download"
                                                    className="w-4 h-4"
                                                />
                                            </a>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p className="text-center text-gray-500">
                                    Data peraturan belum tersedia.
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            </section>

            <section className="bg-[#f1f1f1] px-4 sm:px-8 lg:px-24 py-12">
                <div className="text-center">
                    <h2 className="text-2xl font-semibold mb-6 font-pontano">
                        Berita
                    </h2>
                </div>
                <div className="text-start">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                        {beritaData.length > 0 ? (
                            beritaData.map((item) => (
                                <div
                                    key={item.id}
                                    className="hover:shadow-md transition-all duration-300 flex flex-col"
                                >
                                    <img
                                        src={item.thumbnail}
                                        alt={item.judul}
                                        className="w-full h-[220px] md:h-[260px] lg:h-[280px] xl:h-[300px] object-cover"
                                    />
                                    <div className="p-4 flex flex-col flex-1">
                                        <h3
                                            className="text-sm font-bold text-gray-900 mb-2 leading-snug"
                                            style={truncateMultiline(2)}
                                        >
                                            {item.judul}
                                        </h3>
                                        <p
                                            className="text-sm text-gray-600 mb-4"
                                            style={truncateMultiline(3)}
                                        >
                                            {stripHtml(item.keterangan)}
                                        </p>
                                        <div className="mt-auto flex justify-center">
                                            <Link
                                                to={`/berita/${item.id}`}
                                                className="text-[#EB0A1E] text-sm font-bold inline-flex items-center gap-1 hover:underline"
                                            >
                                                Selengkapnya{" "}
                                                <img
                                                    src="/images/asset/arrow.svg"
                                                    alt="arrow"
                                                    className="w-4 h-4 object-contain"
                                                />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="text-center text-gray-500">
                                Data berita belum tersedia.
                            </p>
                        )}
                    </div>
                </div>
            </section>

            <section className="bg-[#F1F1F1] px-4 sm:px-8 lg:px-24 py-12">
                <div className="text-center">
                    <h2 className="text-2xl font-semibold mb-8 font-pontano">
                        Frequently Asked Question
                    </h2>
                    <div className="max-w-6xl mx-auto space-y-3">
                        {faqs.length > 0 ? (
                            faqs.map((item, index) => (
                                <div
                                    className="collapse collapse-arrow bg-white rounded-xl shadow"
                                    key={index}
                                >
                                    <input type="checkbox" />
                                    <div className="collapse-title text-sm font-semibold text-left text-redPrimary font-pontano">
                                        <div className="text-redPrimary text-xs font-inter">
                                            Question
                                        </div>
                                        <span className="text-gray-800">
                                            {item.pertanyaan}
                                        </span>
                                    </div>
                                    <div className="collapse-content text-sm text-gray-800 pt-0 text-start font-inter">
                                        {item.jawaban}
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="text-gray-500 text-sm font-inter">
                                Data FAQ belum tersedia
                            </p>
                        )}
                    </div>
                </div>
            </section>
        </>
    );
};

export default Beranda;
